import { useCallback } from 'react';
import {
  SuccessCallback,
  useActionPipeline,
  useDialogState,
  useToast,
} from 'hooks';
import { useIntl } from 'react-intl';
import { commonTexts } from 'i18n';
import { changeStatus } from 'store/scorecards';
import { SCORECARD_ACTION_ASSESSMENT_REOPEN } from 'constants/scorecards';
import { useScorecardContext } from 'contexts';

export default function useGatherMoreFeedback() {
  const { id, store } = useScorecardContext();
  const [
    isGatherMoreFeedbackDialogActive,
    openGatherMoreFeedbackDialog,
    onGatherMoreFeedbackDialogClose,
  ] = useDialogState();

  const onGatherMoreFeedbackClick = useCallback(() => {
    openGatherMoreFeedbackDialog();
  }, [openGatherMoreFeedbackDialog]);

  const { formatMessage } = useIntl();
  const showMessage = useToast();
  const onGatherMoreFeedbackSuccess = useCallback<SuccessCallback>(() => {
    showMessage({
      severity: 'success',
      message: formatMessage(commonTexts.success),
    });
  }, [showMessage, formatMessage]);

  const gatherMoreFeedbackPipeline = useActionPipeline(
    onGatherMoreFeedbackSuccess,
    null,
    onGatherMoreFeedbackDialogClose,
  );

  const onGatherMoreFeedbackSubmit = useCallback(() => {
    gatherMoreFeedbackPipeline(
      changeStatus({
        id,
        store,
        action: SCORECARD_ACTION_ASSESSMENT_REOPEN,
      }),
    );
  }, [gatherMoreFeedbackPipeline, id, store]);

  return {
    onGatherMoreFeedbackClick,
    isGatherMoreFeedbackDialogActive,
    onGatherMoreFeedbackDialogClose,
    onGatherMoreFeedbackSubmit,
  };
}
